<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Razão Social</th>
        <th scope="col" class="border-0">CNPJ</th>
        <th scope="col" class="border-0">CEP</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="border-0">Região</th>
        <th scope="col" class="border-0">UF</th>
        <th scope="col" class="border-0">Pontuação</th>
        <th scope="col" class="border-0">Criado</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in leads" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-2 link">
          <d-link :to="{ name: 'admin-lead-view', params: { leadId: row.id } }">
            {{ row.name }}
          </d-link>
        </td>
        <td class="td-2">{{ row.cnpj }}</td>
        <td class="td-2">{{ row.zipcode }}</td>
        <td class="td-2">{{ row.phone }}</td>
        <td class="td-2">
          {{ row.city || '-' }}
        </td>
        <td class="td-2">{{ row.state }}</td>
        <td class="td-2">{{ row.score }}</td>
        <td class="td-2">{{ row.created }}</td>
        <td class="td-2">
          <lead-buttons :lead="row" @toggleSpam="toggleSpam" />
        </td>
      </tr>
      <tr v-if="leads.length === 0">
        <td colspan="10" class="no-content">
          Ainda não tem nenhuma indicação cadastrada
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import LeadButtons from './LeadButtons.vue';
import LeadActions from './LeadActions';

export default {
  name: 'lead-table',
  mixins: [LeadActions],
  components: {
    LeadButtons,
  },
  props: {
    leads: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.td {
  &-2 {
    min-width: 140px;
  }
}
</style>
